import React from "react";
import TicketsActionDropdown from "./TicketsActionDropdown";

const TicketsTableRow = ({
  row,
  headers,
  rowKey,
  isDropdownOpen,
  toggleDropdown,
  onActionClick,
  onRowClick,
  rowIndex,
  rowClassName,
  tableStyle,
}) => {
  return (
    <tr
      onClick={() => onRowClick && onRowClick(row)}
      className={`hover:bg-gray-50 bg-white ${onRowClick ? "cursor-pointer" : ""} ${rowClassName || ""}`}
    >
      {headers.map(({ key }) => {
        if (key === "action") {
          return (
            <td
              key={key}
              onClick={(e) => e.stopPropagation()}
              className="py-4 px-4 border-b border-gray-100 text-right align-middle"
            >
              <TicketsActionDropdown
                isOpen={isDropdownOpen}
                onToggle={() => toggleDropdown(rowIndex)}
                onAction={(action) => onActionClick(action, row)}
                row={row}
              />
            </td>
          );
        }

        let content;
        if (key === "id") {
          content = <span className="text-gray-600 font-ubuntu">{row.id}</span>;
        } else if (key === "subject") {
          content = <span className="text-gray-800 font-ubuntu">{row.subject}</span>;
        } else if (key === "requester_name") {
          content = (
            <div className="flex items-center font-ubuntu">
              <div className="w-8 h-8 rounded bg-orange-500 text-white flex items-center justify-center font-bold mr-3 text-sm flex-shrink-0">
                {row.requester_name ? row.requester_name.charAt(0).toUpperCase() : "U"}
              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-gray-800 text-sm">{row.requester_name}</span>
                <span className="text-xs text-gray-400">ID: {row.requester_id}</span>
              </div>
            </div>
          );
        } else if (key === "created_at") {
          // Format as DD-MM-YYYY
          const d = row.created_at ? new Date(row.created_at) : null;
          const formattedDate = d ? `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}` : "N/A";
          content = <span className="text-gray-600 font-ubuntu">{formattedDate}</span>;
        } else if (key === "others") {
          content = (
            <div className="flex flex-col text-xs text-gray-500 font-ubuntu">
              <div>Agent: <span className="text-gray-700">{row.agent || "N/A"}</span></div>
              <div>Priority: <span className="text-gray-700">{row.priority || "N/A"}</span></div>
              {(() => {
                let tagsArray = [];
                if (Array.isArray(row.tags)) {
                  tagsArray = row.tags;
                } else if (typeof row.tags === 'string') {
                  try {
                    // Try parsing as JSON first
                    tagsArray = JSON.parse(row.tags);
                    if (!Array.isArray(tagsArray)) tagsArray = [row.tags];
                  } catch (e) {
                    // Fallback to comma separated
                    tagsArray = row.tags.split(',').map(t => t.trim()).filter(Boolean);
                  }
                }
                
                return tagsArray.length > 0 && (
                  <div className="flex gap-1 mt-1 flex-wrap">
                    {tagsArray.map((tag, i) => (
                      <span key={i} className={`text-[10px] px-1.5 py-0.5 rounded ${tag.toLowerCase() === 'test' ? 'bg-yellow-100 text-yellow-700' : 'bg-green-100 text-green-700'}`}>{tag}</span>
                    ))}
                  </div>
                );
              })()}
            </div>
          );
        } else if (key === "statusLabel") {
          const statusColors = {
            "Open": { bg: "bg-red-50", text: "text-red-500", dot: "bg-red-500" },
            "Assigned": { bg: "bg-blue-50", text: "text-blue-500", dot: "bg-blue-500" },
            "Resolved": { bg: "bg-green-50", text: "text-green-500", dot: "bg-green-500" },
            "Closed": { bg: "bg-gray-100", text: "text-gray-500", dot: "bg-gray-500" }
          };
          const st = row.statusLabel || row.status || "";
          const color = statusColors[st] || statusColors["Closed"];
          content = (
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold font-ubuntu ${color.bg} ${color.text}`}>
              <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${color.dot}`} />
              {st}
            </span>
          );
        } else {
          content = row[key] || "N/A";
        }

        return (
          <td
            key={key}
            className="py-4 px-4 border-b border-gray-100 text-sm align-middle"
            style={tableStyle}
          >
            {content}
          </td>
        );
      })}
    </tr>
  );
};

export default TicketsTableRow;
